<template>
    <div>
        <Player v-on:cart-add-player="CartAddPlayer" v-for="player in players" :player="player"></Player>
    </div>
</template>

<script>
    import Player from "./Player";

    export default {
        name: "Catalog",
        components: {Player},
        props: {
            players: Array
        },
        methods: {
            CartAddPlayer: function (aPlayer) {
                // On reemet l'event pour le niveau sup
                this.$emit('cart-add-player', aPlayer);
            }
        }
    }
</script>

<style scoped>

</style>